/** Enum that matches the values in the subscription_type table */
export enum SubscriptionTypes {
  lead = 4,
  normal = 1,
  preferred = 5,
}

export enum ContentFilterTypes {
  blacklist = 'blacklist',
  whitelist = 'whitelist',
}

export enum SourceTypes {
  facebook = 'Facebook',
  googleNews = 'Google News',
  instagram = 'Instagram',
  linkedIn = 'LinkedIn',
  native = 'Manual Entry',
  pocket = 'Pocket',
  podcast = 'Podcast',
  rss = 'RSS Feed',
  scraper = 'Scraper',
  twitter = 'Twitter',
  twitterList = 'Twitter List',
  upcontent = 'UpContent',
  youtube = 'YouTube',
}

export enum EmailTemplates {
  bigAndBold = 'self-service-big-bold.html.jinja',
  default = 'self-service-default.html.jinja',
  newspaper = 'self-service-newspaper.html.jinja',
  insights = 'self-service-insights.html.jinja',
  oldBigAndBold = 'self-service-big-bold.jinja',
  oldDefault = 'self-service-default.jinja',
  oldNewspaper = 'self-service-newspaper.jinja',
}

export enum DomainStatus {
  valid = 'valid',
  invalid = 'invalid',
  pending = 'pending',
  deleted = 'deleted',
}

export enum EmailVerificationStatus {
  confirmed = 'confirmed',
  pending = 'pending',
  unknown = 'unknown',
  failed = 'failed',
}

export enum RasaEmailFooterImages {
  large = 'https://image-api.rasa.io/image/hosted-images-newsbrief/path/rasa/rasa_io-logo-white_outline-words.png?w=200&h=80',
}

export enum EmailAttributes {
  brandFooterImageUrl = 'brand_footer_image_url',
  brandHeaderImageUrl = 'brand_header_image_url',
  brandHeaderUrl = 'brand_header_url',
  brandFooterUrl = 'brand_footer_url',
  categoryTypeIdForSubject = 'category_type_id_for_subject',
  companyCityStateZip = 'company_city_state_zip',
  companyName = 'company_name',
  companyStreetAddress = 'company_street_address',
  companyWebsite = 'company_website',
  contactUsUrl = 'contact_url',
  contactUsUrlText = 'contact_url_text',
  descriptionCapText = 'description_cap_text',
  descriptionCharacterLimit = 'description_character_limit',
  descriptionLength = 'description_length',
  emailBodyBackgroundColor = 'email_body_background_color',
  emailSubject = 'email_subject',
  emailTemplate = 'email_template',
  facebookName = 'facebook_icon_link',
  feedbackUrlText = 'feedback_url_text',
  fontColor = 'font_color',
  fontFamily = 'font_family',
  fontSize = 'font_size',
  fontWeight = 'font_weight',
  footerCopyRightText = 'footer_copyright_text',
  footerFontColor = 'footer_font_color',
  footerLogoSize = 'footer_logo_size',
  footerTextFieldOne = 'footer_text_field_one',
  footerTextFieldTwo = 'footer_text_field_two',
  fromEmail = 'from_address',
  fromName = 'from_address_name',
  headerDateFormat = 'header_date_format',
  subjectDateFormat = 'subject_date_format',
  hideHeaderBackground = 'hide_header_background',
  htmlEditing = 'html_editing',
  instagramName = 'instagram_icon_link',
  leadText = 'lead_text',
  leadTextColor = 'lead_text_color',
  leadTextFontSize = 'lead_text_font_size',
  leadTextFontWeight = 'lead_text_font_weight',
  leadTextFontStyle = 'lead_text_font_style',
  leadTextHtmlEditing = 'lead_text_html_editing',
  leadTextBorderColor = 'lead_text_border_color',
  leadTextBorderWidth = 'lead_text_border_width',
  leadTextIsActive = 'lead_text_is_active',
  leadText2 = 'lead_text_2',
  leadText2Color = 'lead_text_2_color',
  leadText2FontSize = 'lead_text_2_font_size',
  leadText2FontWeight = 'lead_text_2_font_weight',
  leadText2FontStyle = 'lead_text_2_font_style',
  leadText2HtmlEditing = 'lead_text_2_html_editing',
  leadText2BorderColor = 'lead_text_2_border_color',
  leadText2BorderWidth = 'lead_text_2_border_width',
  leadText2IsActive = 'lead_text_2_is_active',
  learnMoreUrl = 'learn_more_url',
  learnMoreUrlText = 'learn_more_url_text',
  linkedInName = 'linkedin_icon_link',
  logoSize = 'logo_size',
  maxArticles = 'newsbrief_count',
  maxArticlesPerSource = 'max_per_source',
  maxLeadArticles = 'max_lead_count',
  maxSponsoredArticles = 'max_sponsored_articles',
  minArticles = 'minimum_newsbrief_count',
  newsletterFontFamily = 'newsletter_font_family',
  previewText = 'preview_text',
  primaryColor = 'primary_color',
  readMoreText = 'read_more_text',
  restrictNewsletterImages = 'restrict_newsletter_images',
  secondaryColor = 'secondary_color',
  showNewsletterImages = 'show_newsletter_images',
  showRasaLogo = 'show_rasa_logo',
  showSectionNameInHeader = 'show_section_name_in_header',
  showSubscribeUrlInHeader = 'show_subscribe_url_in_header',
  showUnsubscribeUrlInHeader = 'show_unsubscribe_url_in_header',
  staticImages = 'static_images',
  staticTexts = 'static_texts',
  subscribeUrl = 'subscribe_url',
  subscribeUrlText = 'subscribe_url_text',
  titleCapText = 'title_cap_text',
  titleFontColor = 'title_font_color',
  twitterName = 'twitter_icon_link',
  unsubscribeUrl = 'unsubscribe_url',
  unsubscribeUrlText = 'unsubscribe_url_text',
  viewInBrowser = 'view_in_browser',
  whitelabelLogoUrl = 'whitelabel_logo_url',
  youtubeName = 'youtube_icon_link',
  communityPartnerCode = 'community_partner_code',
}

export enum ScheduleFrequency {
  biweekly = 'biweekly',
  daily = 'daily',
  manually = 'manually',
  monthly = 'monthly',
  none = 'none',
  weekly = 'weekly',
}

export interface LeadTextAttributes {
  borderColor: string,
  borderWidth: string,
  color: string,
  fontSize: string,
  fontStyle: string,
  fontWeight: string,
  isHtmlEdited: string,
  isActive: string,
  text: string,
}

export const leadTextAttributes: LeadTextAttributes = {
  borderColor: 'border-color',
  borderWidth: 'border-width',
  color: 'color',
  fontSize: 'font-size',
  fontStyle: 'font-style',
  fontWeight: 'font-weight',
  isActive: 'is_active',
  isHtmlEdited: 'is_edited',
  text: 'description',
}

export interface LeadTextDefaults {
  borderColor: string,
  borderWidth: string,
  color: string,
  fontSize: string,
  fontStyle: string,
  fontWeight: string,
  isHtmlEdited: boolean,
  isActive: boolean,
  text: string,
}

export const leadTextDefaults: LeadTextDefaults = {
  borderColor: '#000000',
  borderWidth: '0px',
  color: '#000000',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '500',
  isActive: null,
  isHtmlEdited: false,
  text: null,
}

export const DEFAULT_TIMEZONE = 'US/Central'
export const DATE_FORMAT = 'ccc, MMM dd, yyyy'
export const DATE_TIME_FORMAT = 'ccc, MMM dd, yyyy HH:MM'
export const DATE_FORMAT_MOBILE = 'MMM dd'
export const CAPPED = 'AccountLimitFailure'

export const VALID_TIMEZONES = [
  'Africa/Abidjan', 'Africa/Accra', 'Africa/Addis_Ababa', 'Africa/Algiers', 'Africa/Asmara', 'Africa/Asmera',
  'Africa/Bamako', 'Africa/Bangui', 'Africa/Banjul', 'Africa/Bissau', 'Africa/Blantyre', 'Africa/Brazzaville',
  'Africa/Bujumbura', 'Africa/Cairo', 'Africa/Casablanca', 'Africa/Ceuta', 'Africa/Conakry', 'Africa/Dakar',
  'Africa/Dar_es_Salaam', 'Africa/Djibouti', 'Africa/Douala', 'Africa/El_Aaiun', 'Africa/Freetown', 'Africa/Gaborone',
  'Africa/Harare', 'Africa/Johannesburg', 'Africa/Juba', 'Africa/Kampala', 'Africa/Khartoum', 'Africa/Kigali',
  'Africa/Kinshasa', 'Africa/Lagos', 'Africa/Libreville', 'Africa/Lome', 'Africa/Luanda', 'Africa/Lubumbashi',
  'Africa/Lusaka', 'Africa/Malabo', 'Africa/Maputo', 'Africa/Maseru', 'Africa/Mbabane', 'Africa/Mogadishu',
  'Africa/Monrovia', 'Africa/Nairobi', 'Africa/Ndjamena', 'Africa/Niamey', 'Africa/Nouakchott', 'Africa/Ouagadougou',
  'Africa/Porto-Novo', 'Africa/Sao_Tome', 'Africa/Timbuktu', 'Africa/Tripoli', 'Africa/Tunis', 'Africa/Windhoek',
  'America/Adak', 'America/Anchorage', 'America/Anguilla', 'America/Antigua', 'America/Araguaina',
  'America/Argentina/Buenos_Aires', 'America/Argentina/Catamarca', 'America/Argentina/ComodRivadavia',
  'America/Argentina/Cordoba', 'America/Argentina/Jujuy', 'America/Argentina/La_Rioja', 'America/Argentina/Mendoza',
  'America/Argentina/Rio_Gallegos', 'America/Argentina/Salta', 'America/Argentina/San_Juan',
  'America/Argentina/San_Luis', 'America/Argentina/Tucuman', 'America/Argentina/Ushuaia', 'America/Aruba',
  'America/Asuncion', 'America/Atikokan', 'America/Atka', 'America/Bahia', 'America/Bahia_Banderas',
  'America/Barbados', 'America/Belem', 'America/Belize', 'America/Blanc-Sablon', 'America/Boa_Vista',
  'America/Bogota', 'America/Boise', 'America/Buenos_Aires', 'America/Cambridge_Bay', 'America/Campo_Grande',
  'America/Cancun', 'America/Caracas', 'America/Catamarca', 'America/Cayenne', 'America/Cayman', 'America/Chicago',
  'America/Chihuahua', 'America/Coral_Harbour', 'America/Cordoba', 'America/Costa_Rica', 'America/Creston',
  'America/Cuiaba', 'America/Curacao', 'America/Danmarkshavn', 'America/Dawson', 'America/Dawson_Creek',
  'America/Denver', 'America/Detroit', 'America/Dominica', 'America/Edmonton', 'America/Eirunepe',
  'America/El_Salvador', 'America/Ensenada', 'America/Fort_Nelson', 'America/Fort_Wayne', 'America/Fortaleza',
  'America/Glace_Bay', 'America/Godthab', 'America/Goose_Bay', 'America/Grand_Turk', 'America/Grenada',
  'America/Guadeloupe', 'America/Guatemala', 'America/Guayaquil', 'America/Guyana', 'America/Halifax',
  'America/Havana', 'America/Hermosillo', 'America/Indiana/Indianapolis', 'America/Indiana/Knox',
  'America/Indiana/Marengo', 'America/Indiana/Petersburg', 'America/Indiana/Tell_City', 'America/Indiana/Vevay',
  'America/Indiana/Vincennes', 'America/Indiana/Winamac', 'America/Indianapolis', 'America/Inuvik',
  'America/Iqaluit', 'America/Jamaica', 'America/Jujuy', 'America/Juneau', 'America/Kentucky/Louisville',
  'America/Kentucky/Monticello', 'America/Knox_IN', 'America/Kralendijk', 'America/La_Paz', 'America/Lima',
  'America/Los_Angeles', 'America/Louisville', 'America/Lower_Princes', 'America/Maceio', 'America/Managua',
  'America/Manaus', 'America/Marigot', 'America/Martinique', 'America/Matamoros', 'America/Mazatlan',
  'America/Mendoza', 'America/Menominee', 'America/Merida', 'America/Metlakatla', 'America/Mexico_City',
  'America/Miquelon', 'America/Moncton', 'America/Monterrey', 'America/Montevideo', 'America/Montreal',
  'America/Montserrat', 'America/Nassau', 'America/New_York', 'America/Nipigon', 'America/Nome',
  'America/Noronha', 'America/North_Dakota/Beulah', 'America/North_Dakota/Center', 'America/North_Dakota/New_Salem',
  'America/Ojinaga', 'America/Panama', 'America/Pangnirtung', 'America/Paramaribo', 'America/Phoenix',
  'America/Port-au-Prince', 'America/Port_of_Spain', 'America/Porto_Acre', 'America/Porto_Velho',
  'America/Puerto_Rico', 'America/Punta_Arenas', 'America/Rainy_River', 'America/Rankin_Inlet', 'America/Recife',
  'America/Regina', 'America/Resolute', 'America/Rio_Branco', 'America/Rosario', 'America/Santa_Isabel',
  'America/Santarem', 'America/Santiago', 'America/Santo_Domingo', 'America/Sao_Paulo', 'America/Scoresbysund',
  'America/Shiprock', 'America/Sitka', 'America/St_Barthelemy', 'America/St_Johns', 'America/St_Kitts',
  'America/St_Lucia', 'America/St_Thomas', 'America/St_Vincent', 'America/Swift_Current', 'America/Tegucigalpa',
  'America/Thule', 'America/Thunder_Bay', 'America/Tijuana', 'America/Toronto', 'America/Tortola', 'America/Vancouver',
  'America/Virgin', 'America/Whitehorse', 'America/Winnipeg', 'America/Yakutat', 'America/Yellowknife',
  'Antarctica/Casey', 'Antarctica/Davis', 'Antarctica/DumontDUrville', 'Antarctica/Macquarie',
  'Antarctica/Mawson', 'Antarctica/McMurdo', 'Antarctica/Palmer', 'Antarctica/Rothera',
  'Antarctica/South_Pole', 'Antarctica/Syowa', 'Antarctica/Troll', 'Antarctica/Vostok',
  'Arctic/Longyearbyen', 'Asia/Aden', 'Asia/Almaty', 'Asia/Amman', 'Asia/Anadyr', 'Asia/Aqtau',
  'Asia/Aqtobe', 'Asia/Ashgabat', 'Asia/Ashkhabad', 'Asia/Atyrau', 'Asia/Baghdad', 'Asia/Bahrain',
  'Asia/Baku', 'Asia/Bangkok', 'Asia/Barnaul', 'Asia/Beirut', 'Asia/Bishkek', 'Asia/Brunei', 'Asia/Calcutta',
  'Asia/Chita', 'Asia/Choibalsan', 'Asia/Chongqing', 'Asia/Chungking', 'Asia/Colombo', 'Asia/Dacca', 'Asia/Damascus',
  'Asia/Dhaka', 'Asia/Dili', 'Asia/Dubai', 'Asia/Dushanbe', 'Asia/Famagusta', 'Asia/Gaza', 'Asia/Harbin',
  'Asia/Hebron', 'Asia/Ho_Chi_Minh', 'Asia/Hong_Kong', 'Asia/Hovd', 'Asia/Irkutsk', 'Asia/Istanbul', 'Asia/Jakarta',
  'Asia/Jayapura', 'Asia/Jerusalem', 'Asia/Kabul', 'Asia/Kamchatka', 'Asia/Karachi', 'Asia/Kashgar', 'Asia/Kathmandu',
  'Asia/Katmandu', 'Asia/Khandyga', 'Asia/Kolkata', 'Asia/Krasnoyarsk', 'Asia/Kuala_Lumpur', 'Asia/Kuching',
  'Asia/Kuwait', 'Asia/Macao', 'Asia/Macau', 'Asia/Magadan', 'Asia/Makassar', 'Asia/Manila', 'Asia/Muscat',
  'Asia/Nicosia', 'Asia/Novokuznetsk', 'Asia/Novosibirsk', 'Asia/Omsk', 'Asia/Oral', 'Asia/Phnom_Penh',
  'Asia/Pontianak', 'Asia/Pyongyang', 'Asia/Qatar', 'Asia/Qyzylorda', 'Asia/Rangoon', 'Asia/Riyadh', 'Asia/Saigon',
  'Asia/Sakhalin', 'Asia/Samarkand', 'Asia/Seoul', 'Asia/Shanghai', 'Asia/Singapore', 'Asia/Srednekolymsk',
  'Asia/Taipei', 'Asia/Tashkent', 'Asia/Tbilisi', 'Asia/Tehran', 'Asia/Tel_Aviv', 'Asia/Thimbu', 'Asia/Thimphu',
  'Asia/Tokyo', 'Asia/Tomsk', 'Asia/Ujung_Pandang', 'Asia/Ulaanbaatar', 'Asia/Ulan_Bator', 'Asia/Urumqi',
  'Asia/Ust-Nera', 'Asia/Vientiane', 'Asia/Vladivostok', 'Asia/Yakutsk', 'Asia/Yangon', 'Asia/Yekaterinburg',
  'Asia/Yerevan', 'Atlantic/Azores', 'Atlantic/Bermuda', 'Atlantic/Canary', 'Atlantic/Cape_Verde', 'Atlantic/Faeroe',
  'Atlantic/Faroe', 'Atlantic/Jan_Mayen', 'Atlantic/Madeira', 'Atlantic/Reykjavik', 'Atlantic/South_Georgia',
  'Atlantic/St_Helena', 'Atlantic/Stanley', 'Australia/ACT', 'Australia/Adelaide', 'Australia/Brisbane',
  'Australia/Broken_Hill', 'Australia/Canberra', 'Australia/Currie', 'Australia/Darwin', 'Australia/Eucla',
  'Australia/Hobart', 'Australia/LHI', 'Australia/Lindeman', 'Australia/Lord_Howe', 'Australia/Melbourne',
  'Australia/NSW', 'Australia/North', 'Australia/Perth', 'Australia/Queensland', 'Australia/South',
  'Australia/Sydney', 'Australia/Tasmania', 'Australia/Victoria', 'Australia/West', 'Australia/Yancowinna',
  'Brazil/Acre', 'Brazil/DeNoronha', 'Brazil/East', 'Brazil/West', 'CET', 'CST6CDT', 'Canada/Atlantic',
  'Canada/Central', 'Canada/Eastern', 'Canada/Mountain', 'Canada/Newfoundland', 'Canada/Pacific',
  'Canada/Saskatchewan', 'Canada/Yukon', 'Chile/Continental', 'Chile/EasterIsland', 'Cuba', 'EET', 'EST', 'EST5EDT',
  'Egypt', 'Eire', 'Etc/GMT', 'Etc/GMT+0', 'Etc/GMT+1', 'Etc/GMT+10', 'Etc/GMT+11', 'Etc/GMT+12', 'Etc/GMT+2',
  'Etc/GMT+3', 'Etc/GMT+4', 'Etc/GMT+5', 'Etc/GMT+6', 'Etc/GMT+7', 'Etc/GMT+8', 'Etc/GMT+9', 'Etc/GMT-0',
  'Etc/GMT-1', 'Etc/GMT-10', 'Etc/GMT-11', 'Etc/GMT-12', 'Etc/GMT-13', 'Etc/GMT-14', 'Etc/GMT-2', 'Etc/GMT-3',
  'Etc/GMT-4', 'Etc/GMT-5', 'Etc/GMT-6', 'Etc/GMT-7', 'Etc/GMT-8', 'Etc/GMT-9', 'Etc/GMT0', 'Etc/Greenwich',
  'Etc/UCT', 'Etc/UTC', 'Etc/Universal', 'Etc/Zulu', 'Europe/Amsterdam', 'Europe/Andorra', 'Europe/Astrakhan',
  'Europe/Athens', 'Europe/Belfast', 'Europe/Belgrade', 'Europe/Berlin', 'Europe/Bratislava', 'Europe/Brussels',
  'Europe/Bucharest',  'Europe/Budapest', 'Europe/Busingen', 'Europe/Chisinau', 'Europe/Copenhagen',
  'Europe/Dublin', 'Europe/Gibraltar', 'Europe/Guernsey', 'Europe/Helsinki', 'Europe/Isle_of_Man', 'Europe/Istanbul',
  'Europe/Jersey', 'Europe/Kaliningrad', 'Europe/Kiev', 'Europe/Kirov', 'Europe/Lisbon', 'Europe/Ljubljana',
  'Europe/London', 'Europe/Luxembourg', 'Europe/Madrid', 'Europe/Malta', 'Europe/Mariehamn', 'Europe/Minsk',
  'Europe/Monaco', 'Europe/Moscow', 'Europe/Nicosia', 'Europe/Oslo', 'Europe/Paris', 'Europe/Podgorica',
  'Europe/Prague', 'Europe/Riga', 'Europe/Rome', 'Europe/Samara', 'Europe/San_Marino', 'Europe/Sarajevo',
  'Europe/Saratov', 'Europe/Simferopol', 'Europe/Skopje', 'Europe/Sofia', 'Europe/Stockholm', 'Europe/Tallinn',
  'Europe/Tirane', 'Europe/Tiraspol', 'Europe/Ulyanovsk', 'Europe/Uzhgorod', 'Europe/Vaduz', 'Europe/Vatican',
  'Europe/Vienna', 'Europe/Vilnius', 'Europe/Volgograd', 'Europe/Warsaw', 'Europe/Zagreb', 'Europe/Zaporozhye',
  'Europe/Zurich', 'GB', 'GB-Eire', 'GMT', 'GMT+0', 'GMT-0', 'GMT0', 'Greenwich', 'HST', 'Hongkong', 'Iceland',
  'Indian/Antananarivo', 'Indian/Chagos', 'Indian/Christmas', 'Indian/Cocos', 'Indian/Comoro', 'Indian/Kerguelen',
  'Indian/Mahe', 'Indian/Maldives', 'Indian/Mauritius', 'Indian/Mayotte', 'Indian/Reunion', 'Iran', 'Israel',
  'Jamaica', 'Japan', 'Kwajalein', 'Libya', 'MET', 'MST', 'MST7MDT', 'Mexico/BajaNorte', 'Mexico/BajaSur',
  'Mexico/General', 'NZ', 'NZ-CHAT', 'Navajo', 'PRC', 'PST8PDT', 'Pacific/Apia', 'Pacific/Auckland',
  'Pacific/Bougainville', 'Pacific/Chatham', 'Pacific/Chuuk', 'Pacific/Easter', 'Pacific/Efate', 'Pacific/Enderbury',
  'Pacific/Fakaofo', 'Pacific/Fiji', 'Pacific/Funafuti', 'Pacific/Galapagos', 'Pacific/Gambier', 'Pacific/Guadalcanal',
  'Pacific/Guam', 'Pacific/Honolulu', 'Pacific/Johnston', 'Pacific/Kiritimati', 'Pacific/Kosrae', 'Pacific/Kwajalein',
  'Pacific/Majuro', 'Pacific/Marquesas', 'Pacific/Midway', 'Pacific/Nauru', 'Pacific/Niue', 'Pacific/Norfolk',
  'Pacific/Noumea', 'Pacific/Pago_Pago', 'Pacific/Palau', 'Pacific/Pitcairn', 'Pacific/Pohnpei', 'Pacific/Ponape',
  'Pacific/Port_Moresby', 'Pacific/Rarotonga', 'Pacific/Saipan', 'Pacific/Samoa', 'Pacific/Tahiti', 'Pacific/Tarawa',
  'Pacific/Tongatapu', 'Pacific/Truk', 'Pacific/Wake', 'Pacific/Wallis', 'Pacific/Yap', 'Poland', 'Portugal', 'ROC',
  'ROK', 'Singapore', 'Turkey', 'UCT',
  'US/Alaska', 'US/Aleutian', 'US/Arizona', 'US/Central', 'US/East-Indiana', 'US/Eastern', 'US/Hawaii',
  'US/Indiana-Starke', 'US/Michigan', 'US/Mountain', 'US/Pacific', 'US/Samoa',
  'UTC', 'Universal', 'W-SU', 'WET', 'Zulu',
]

export const DASHBOARD_ACCOUNT_PAGE = '/settings/account'
export const DASHBOARD = 'dashboard'
export const UNLIMITED_VALUE = 1000000
export const ADD = 'add'
export const IMAGE = 'image'
export const BANNER_IMAGE_MODULE = 'image'
export const SQUARE_IMAGE_MODULE = 'twoColumnImage'
export const LEFT_SQUARE = 'leftSquare'
export const RIGHT_SQUARE = 'rightSquare'
export const TEXT = 'text'
export const ARTICLE = 'article'
export const LEAD_TEXT_TYPE_PREFIX = 'Text'
export const SPONSORED = 'sponsored'

export enum ScheduledContentTypes {
  article = 'scheduledArticle',
  image = 'scheduledImage',
  sponsored = 'sponsoredArticle',
  text = 'scheduledText',
}

export enum PlanUpdateTypes {
  UPGRADE = 'plan-upgrade',
  DOWNGRADE = 'plan-downgrade',
  CANCELLATION = 'plan-cancellation',
  NEW_PAID_SUBSCRIPTION = 'new-paid-subscription',
  CONTACT_UPGRADE = 'contact-upgrade',
  CONTACT_DOWNGRADE = 'contact-downgrade',
}

export const NO_BOOST_LEVEL = 0
export const NORMAL_BOOSTED_BOOST_LEVEL = 1
export const SCHEDULED_ARTICLES_BOOST_LEVEL = 5
export const SUPER_BOOSTED_BOOST_LEVEL = 10

export const RASA_IMAGE_API_ENDPOINT = 'https://image-api.rasa.io/image'

export const DEFAULT_MAX_SPONSORED_CONTENT = 4
export const DEFAULT_MAX_LAYOUT_MODULES = 0

export enum UNSUBSCRIBE_REASON {
  ADMIN_UI = 'AdminUI',
  API = 'API',
  BOUNCE = 'Bounce',
  CSV = 'CSV',
  DROPPED = 'Dropped',
  ONE_CLICK_UNSUBSCRIBE = 'OneClickUnsubscribe',
  SOFT_BOUNCE = 'SoftBounce',
  SPAM_REPORT = 'SpamReport',
  UI = 'UI',
  UNSUBSCRIBED = 'Unsubscribed',
  OTHERS = 'Others'
}

export enum DEFAULT_COMMUNITY_PARTNER_CODES {
  ALL = "All",
  NO_CODE = "No Code",
}

export const TEMPLATE_MODULES = 'template_modules'
export const DUMMY_DATE = '1970-01-01 00:00:00'
